<template>
    <div :class="sector.active ? 'semi-card active': 'semi-card'"
         :style="{ 'border-color': sector.color }"
         @click="active">
      <div class="text">{{ value.name }}</div>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  name: 'SectorItem',
  data() {
    return {
      sector: this.value,
    };
  },
  methods: {
    active() {
      this.sector.active = !this.sector.active;
      this.$emit('value', this.sector);
    },
  },
};
</script>

<style lang="scss" scoped>
  .semi-card {
    cursor: pointer;
    box-sizing: border-box;
    background-color: white;
    border-radius: 3px;
    /* flex: 0.3 1 auto; */
    margin: 5px;
    text-align: left;
    color: #999;
    font-size: 12px;
    font-weight: bolder;
    opacity: 0.6;
    .text {
      margin-left: 5px;
      display: inline-block;
    }
    &:before {
      content: "\e719";
      color: rgba(255,255,255,.6);
      margin-right: 5px;
      font-size: 15px;
      margin-left: -18px;
      line-height: 20px;
      font-family: "element-icons" !important;
    }
    &:hover{
      opacity: 0.8;
      color: #555;
      &:before {
        content: "\e71c";
        color: white;
      }
    }
    padding: 3px 10px 3px 0;
    border-left: solid 21px #fafafa;
    box-shadow: 1px 1px 3px rgba(0,0,0,.2);
    &.active{
      &:before {
        content: "\e709";
        color: white;
      }
      opacity: 1;
      color: #444;
    }
  }
</style>
